export default "__VITE_ASSET__WXMWq$xe__"